var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33203 8.00065C1.33203 4.04261 4.54066 0.833984 8.4987 0.833984C12.4567 0.833984 15.6654 4.04261 15.6654 8.00065C15.6654 11.9587 12.4567 15.1673 8.4987 15.1673C4.54065 15.1673 1.33203 11.9587 1.33203 8.00065ZM8.4987 1.83398C5.09294 1.83398 2.33203 4.59489 2.33203 8.00065C2.33203 11.4064 5.09294 14.1673 8.4987 14.1673C11.9044 14.1673 14.6654 11.4064 14.6654 8.00065C14.6654 4.59489 11.9044 1.83398 8.4987 1.83398Z",
    fill: "#476E19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4855 5.61786C11.6976 5.79464 11.7263 6.10992 11.5495 6.32206L8.21614 10.3221C8.12621 10.43 7.99502 10.4951 7.85469 10.5015C7.71435 10.5078 7.57781 10.4549 7.47848 10.3555L5.47848 8.35552C5.28322 8.16026 5.28322 7.84367 5.47848 7.64841C5.67374 7.45315 5.99032 7.45315 6.18558 7.64841L7.79843 9.26126L10.7813 5.68187C10.958 5.46974 11.2733 5.44107 11.4855 5.61786Z",
    fill: "#476E19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckCircle);
export default __webpack_public_path__ + "static/media/ic-check-circle.7611b0e2456a0588fa84366f8c4d0008.svg";
export { ForwardRef as ReactComponent };